package us.laantech.admin.menu.clients.ads.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import kotlinx.coroutines.delay
import us.laantech.admin.menu.clients.ads.LocalAdConfigViewModel
import us.laantech.admin.menu.clients.ads.s3FileName
import kotlin.time.Duration.Companion.seconds

@Composable
fun AdPreview(modifier: Modifier = Modifier) {

    val uiState by LocalAdConfigViewModel.current.uiState.collectAsStateWithLifecycle()

    SectionPanel(title = "Preview Area", modifier = modifier) {

        val sequence = uiState.adSequence
        var currentIndex by remember(sequence.size) { mutableStateOf(0) }

        // Rotate through the ad sequence, advancing every 5 seconds. Manual Previous/Next below
        // mutate the same currentIndex, so both drive the preview.
        LaunchedEffect(sequence) {
            if (sequence.isEmpty()) return@LaunchedEffect
            while (true) {
                delay(uiState.adSequence[currentIndex].durationSeconds?.seconds ?: 5.seconds)
                currentIndex = (currentIndex + 1) % sequence.size
            }
        }

        Box(Modifier.weight(1f).fillMaxWidth(), contentAlignment = Alignment.Center) {
            val currentAd = sequence.getOrNull(currentIndex)
            val url = currentAd?.filename?.let { fn -> uiState.adFileUrls.find { s3FileName(it) == fn } }
            if (url != null) {
                // Fill the available preview box; ContentScale.Fit (S3Preview's default) scales the
                // media to fit inside it, so it resizes with the window and is never cropped.
                S3Preview(url, Modifier.fillMaxSize(), autoPlay = true)
            }
        }

        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
            Button(onClick = {
                if (sequence.isNotEmpty()) {
                    currentIndex = (currentIndex - 1 + sequence.size) % sequence.size
                }
            }) {
                Text(text = "Previous")
            }
            Spacer(Modifier.width(8.dp))
            Button(onClick = {
                if (sequence.isNotEmpty()) {
                    currentIndex = (currentIndex + 1) % sequence.size
                }
            }) {
                Text(text = "Next")
            }
        }
    }
}